import { lazy } from "react";
import { gradients } from "@/lib/constants";
import { ElementDetails } from "@/lib/types";
import { CounterProps } from "./types";

export const details = {
  name: "Counter",
  description: "Count or track anything",
  tags: ["Productivity"],
  category: "Widget",
  setup: lazy(() =>
    import("./Settings").then(m => ({ default: m.CounterSettings })),
  ),
  grid: {
    extraSmall: [1, 1],
    small: [2, 1],
    medium: [2, 2],
  },
  defaultProps: {
    color: gradients[0],
    title: "",
  },
} as ElementDetails<CounterProps>;
